import { Space, Tag, Tooltip, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { ORG_CAPABILITIES, type OrgCapability, type OrgNodeType } from './orgApi'

const CAPABILITY_COLOR: Record<OrgCapability, string> = {
  costCenter: 'purple',
  holdsStock: 'blue',
  settlementParty: 'gold',
  hasEmployees: 'green',
}

export function OrgCapabilityTags({ type }: { type: OrgNodeType | null }) {
  const { t } = useTranslation()
  if (type === null) return <Typography.Text type="secondary">{t('common.dash')}</Typography.Text>

  const enabled = ORG_CAPABILITIES.filter((capability) => type[capability])
  if (enabled.length === 0) {
    return (
      <Tooltip title={t('org.capability.noneHint')}>
        <Typography.Text type="secondary">{t('org.capability.none')}</Typography.Text>
      </Tooltip>
    )
  }

  return (
    <Space size={4} wrap>
      {enabled.map((capability) => (
        <Tooltip key={capability} title={t(`org.capability.${capability}.hint`)}>
          <Tag color={CAPABILITY_COLOR[capability]} style={{ marginInlineEnd: 0 }}>
            {t(`org.capability.${capability}.label`)}
          </Tag>
        </Tooltip>
      ))}
    </Space>
  )
}
